import React from 'react';
import PropTypes from 'prop-types';
import RadioInput from '../Global/Forms/RadioInput';

const SignupPrimaryRole = ({ isCoach, isPlayer, onChange }) => (
  <div className="form-group form-inline">
    <span className="faux-label">Your primary role *</span>
    <p className="like-small color-grey">This will help us personalise your experience</p>

    <div className="form-inline__field-container">
      <RadioInput
        name="isCoach"
        label="Coach"
        onChange={onChange}
        value={isCoach}
        checked={isCoach}
      />

      <RadioInput
        name="isPlayer"
        label="Player"
        onChange={onChange}
        value={isPlayer}
        checked={isPlayer}
      />
    </div>
  </div>
);

SignupPrimaryRole.propTypes = {
  isCoach: PropTypes.bool.isRequired,
  isPlayer: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
};

export default SignupPrimaryRole;



// WEBPACK FOOTER //
// ./library/app/components/Signup/SignupPrimaryRole.js